import {Button, Form, InputGroup, Modal} from "react-bootstrap";
import {createAddress, editAddress} from "../../../Services/ApiService";

function EditAddressModal(props) {
    const address = props.newAddress;

    function handleSaveClicked() {
        if (address.get().id.toString() !== '-1') {
            editAddress(address.get(), () => {props.updateAddresses(() => {})});
        } else {
            createAddress(address.get(), () => {props.updateAddresses(() => {})});
        }
        props.handleClose();
    }

    // noinspection JSValidateTypes
    return (
        <Modal show={props.show} onHide={props.handleClose} size={'md'} id={'editAddressModal'}>
            <Modal.Body>
                <Form>
                    <div className={'clientAddress'}>
                        <div id='address block'>
                            <Form.Control id={`street`}
                                          onChange={e => address.street.set(e.target.value)}
                                          value={address.get().street}
                                          placeholder={'Street'}
                            />
                            <Form.Control id={`street2`}
                                          onChange={e => address.street2.set(e.target.value)}
                                          value={address.get().street2}
                                          placeholder={'Street 2'}
                            />
                            <InputGroup>
                                <Form.Control id={`city`}
                                              onChange={e => address.city.set(e.target.value)}
                                              value={address.get().city}
                                              placeholder={'City'}
                                />
                                <Form.Control className={"addressState"}
                                              onChange={e => address.state.set(e.target.value)}
                                              id={`state`}
                                              value={address.get().state}
                                              placeholder={'State'}
                                />
                                <Form.Control className={"addressZip"}
                                              onChange={e => address.zip.set(e.target.value)}
                                              id={`zip`}
                                              value={address.get().zip}
                                              placeholder={'Zip'}
                                />
                            </InputGroup>
                        </div>
                    </div>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={handleSaveClicked}>Save</Button>
                <Button onClick={props.handleClose}>Cancel</Button>
            </Modal.Footer>
        </Modal>
    )
}

export default EditAddressModal;